import BestekFilter from "@/components/bestek-filter/bestek-filter";
import { BestekFilterParams } from "@/components/bestek-filter/bestek-filter-params";
import FrequentOvksChart from "@/components/charts/frequent-ovks/frequent-ovks";
import { RootState } from "@/store";
import { BestekFilterState } from "@/store/reducers/bestek_filter";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

interface Props {
    bestek_filter: BestekFilterState
}

function mapStateToProps(state: RootState): Props {
    return {
        bestek_filter: state.bestek_filter
    };
}

const OvkStatistics = (props: Props): JSX.Element => {
    const [ params, setParams ] = useState<BestekFilterParams | null>(null);

    const onFilterButtonClick = (params?: BestekFilterParams): void => {
        if (params) {
            setParams(params);
        }
    }

    useEffect(() => {
        if (params === null) {
            onFilterButtonClick();
        }
    });

    return (
        <div>
            <div className="mt-4">
                <BestekFilter onFilterButtonClick={onFilterButtonClick} stateContext="local" />
            </div>

            <div className="mt-4">
                <FrequentOvksChart allowExpand={false} bestekFilterParams={params ?? undefined} />
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(OvkStatistics);